const NafathView = () => import('../screens/NafathView/View/NafathView.vue');

export default [
  {
    component: NafathView,
    meta: {
      activeSidebarItemId: 'nafath-details',
      pageTitle: 'Nafath Details',
    },
    name: 'nafath-details',
    path: '/nafath-details/:id',
    props: true,
  },
];
